/* eslint-disable no-case-declarations */
export const initialState = {
  email: null,
  tac: false,
  pp: false,
  rec_emails: false,
  sessionKey: null,
  sourceOfWealth: null,
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'UPDATE_USER':
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default userReducer;
